import { ApiPathComposer } from "./genPath";
import axiosClient from "./axiosClient";
import { UserCalendarType, UpdateUserCalendarRequest } from "../types/userCalendars/type";

class UserCalendarsAPI {
  // 캘린더 목록 가져오기
  getCalendars() {
    return axiosClient
      .get<UserCalendarType[]>(ApiPathComposer.userCalendars)
      .then((res) => res.data);
  }

  // 캘린더 상세정보 가져오기
  getCalendarDetail(id: number) {
    return axiosClient
      .get<UserCalendarType>(ApiPathComposer.userCalendarDetail(id))
      .then((res) => res.data);
  }

  // 캘린더 설정 수정하기
  updateCalendar(id: number, data: UpdateUserCalendarRequest) {
    return axiosClient
      .patch<UserCalendarType>(ApiPathComposer.userCalendarDetail(id), data)
      .then((res) => res.data);
  }
}

const userCalendarsAPI = new UserCalendarsAPI();
export default userCalendarsAPI;
